module.exports = "/packs/images/homepage/activity/tennis_desktop~720b802796fb20e67847ec17c24f03a0.jpg";